export const createAccountContainer = (slideInMode?: boolean) =>
  `${
    slideInMode
      ? 'w-full px-2 md:px-1'
      : 'md:pb-4 pb-9 w-11/12 md:w-430 px-7 md:px-10 rounded-2xl'
  } bg-elr-white-400  flex flex-col mb-12`;

export const createAccountText = (slideInMode?: boolean) =>
  `${slideInMode ? 'mt-5' : 'mt-14'} mb-7 text-xl text-center`;
